import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { Grid } from 'semantic-ui-react';
import Formsy from 'formsy-react';
import DGTextbox from 'components/FormControls/Textbox/DGTextbox';
import next from '../../assets/images/newui/sellersignup/next-btn.svg'
import servicegrace from '../../assets/images/newui/servicegrace.svg'
import fieldPasswordIcon from '../../assets/images/newui/field-password-icon.png'
import './CompleteProfileContainerNew.less'
import SignupCompleteSuccess from '../../components/SellerSignup/SignupCompleteSuccess';
import { completeProfile, getTOSInfo } from '../../services/Seller';
import ErrorBox from '../../components/SellerSignup/ErrorBox';
import { setSellerProfileCompleted, setTOSSigned} from '../../store/actions/seller';
import { bindActionCreators } from 'redux';
import DGAddressAutoFill from '../../components/FormControls/AddressAutofill/DGAddressAutoFill';

const CompleteProfileContainer = ({ history, setSellerProfileCompleted, setTOSSigned }) => {
    const [formState, setFormState] = useState({ phone: '' })
    const [error, setErrorState] = useState('')
    const [isSuccessVisible, showSuccess] = useState(false)
    const [saving, setSaving] = useState(false)
    const seller = useSelector(({ seller }) => seller);
    const isTOSEnabled = useSelector(({ reducer }) => reducer.isTOSEnabled);
    
    let path = '';
    useEffect(() => {
        if (seller.profileCompleted)
            history.push('/');
        else{
            const autoCompleteInput = document.querySelector('.dgaddress-autofill input');
            
            if(autoCompleteInput){
                autoCompleteInput.setAttribute("tabindex", "1");
            }
        }
    }, [])


    const onSubmit = async (formValue) => {
        const oldPassword = history.location.state ? history.location.state.oldPassword : null;
        setSaving(true);
        const completeProfileResponse = await completeProfile(formValue.address, formValue.businessName, formValue.password, oldPassword);
        if (completeProfileResponse.resStatus == 200) {
            setSaving(false);
            //showSuccess(true);
            setSellerProfileCompleted(true);

            path = await checkTOSSigned();
            if (path) {
                history.push(path);
                return;
            }

            history.push({pathname:'/working-schedules', state: {referrer: "cp"}});
        }
        else {
            setSaving(false);
            if(completeProfileResponse.data.error){
                setErrorState(completeProfileResponse.data.message);
            }
            else{
                setErrorState('Invalid address');
            }
        }
    }

    const checkTOSSigned = async() =>{
        if(isTOSEnabled)
        {
            const tosResponse = await getTOSInfo();
            if (!_.isNull(tosResponse) && !_.isEmpty(tosResponse.data)) {
                const tos = tosResponse.data;
                return `/agreement/${tos.catSEOName}`;
            }
            else {
                setTOSSigned(true);
            }
        }else
        {
            setTOSSigned(true);
        }   
    }

    return <> {!isSuccessVisible && <div className='complete-profile-container'>
        <img src={servicegrace} />
        <div className='complete-profile-heading'>Complete Your Profile</div>
        <div className='complete-profile-sub-heading'>You are almost ready to receive customers</div>
        {error && <ErrorBox message={error} />}
        <Formsy onValidSubmit={onSubmit} className='complete-profile-form'>
            <Grid>
                <Grid.Column mobile={16} tablet={16} computer={16}>
                    <DGTextbox
                        tabIndex={1}
                        placeholder="Star Enterprises" name="businessName" label="Business Name" required
                        maxLength={100}
                        validationErrors={{
                            isDefaultRequiredValue: 'This field is required',
                            isNotBlankString: `This field is required`,

                        }}
                        validations={{
                            isNotBlankString: true
                        }}
                    />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={16}>
                    {/*<DGTextbox
                        tabIndex={2}
                        placeholder="" name="address" label="Business Address" required
                        maxLength={300}
                        validationErrors={{
                            isDefaultRequiredValue: 'Business Address is required',
                            isNotBlankString: `Business Address is required`,

                        }}
                        validations={{
                            isNotBlankString: true
                        }}
                    />*/}
                    <DGAddressAutoFill
                        scrollableParentSelector='.complete-profile-form'
                        innerRef={(c) => {
                            console.log(c);
                        }}
                        onblur={(e) => this.onScroll(e, true)}
                        onfocus={() => {
                            this.onScroll();
                            if (window.innerWidth < 768
                                //&&  !this.isInViewport(document.getElementById("field_"+field.fieldID) , 0)
                            ) {
                                /*setTimeout(() => {
                                    document.getElementById("field_" + field.fieldID).scrollIntoView({
                                        behavior: 'smooth',
                                        //block: 'nearest', 
                                        inline: 'center'
                                    });
                                }, 50);*/
                            }
                        }
                        }
                        name="address"
                        label='Business Address'
                        placeholder=''
                        required
                        
                        validationErrors={{
                            isDefaultRequiredValue: `Business address is required`

                        }}

                    />
                </Grid.Column>
                {history.location.state ? <><Grid.Column mobile={16} tablet={16} computer={16}>
                    <DGTextbox name="password" label="Password" type="password" required
                        validationErrors={{
                            isDefaultRequiredValue: 'Password is required',
                        }}
                        tabIndex={3}
                        icon={fieldPasswordIcon}
                    />
                </Grid.Column>
                    <Grid.Column mobile={16} tablet={16} computer={16}>
                        <DGTextbox name="confirm-password" label="Confirm Password" type="password" required
                            validations={{
                                equalsField: 'password'
                            }}
                            validationErrors={{
                                isDefaultRequiredValue: 'Confirm Password is required',
                                equalsField: 'Both passwords must match.'

                            }}
                            tabIndex={4}
                            icon={fieldPasswordIcon}
                        />
                    </Grid.Column></> : ''}
                <button className='complete-profile-submit' tabIndex={6} type='submit' disabled={saving}>Save Profile <img src={next} /></button>
            </Grid>
        </Formsy>
    </div>}
        {isSuccessVisible && <SignupCompleteSuccess history={history} isTOSEnabled={isTOSEnabled} />}
    </>
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setSellerProfileCompleted,
        setTOSSigned
    }, dispatch);
}

export default connect(null, mapDispatchToProps)(CompleteProfileContainer)